module.exports = __webpack_public_path__ + "img/714C30_EAD7C5_CC9265_E2B48F-256px.aa3c4079.png";